import { createSlice } from "@reduxjs/toolkit";

const plansSlice = createSlice({
  name: "plans",
  initialState: {},
  reducers: {
    updatePlans(state, action) {
      return Object.assign({}, state, action.payload);
    },
  },
});

export const { updatePlans } = plansSlice.actions;

export default plansSlice.reducer;
